module.exports = __webpack_public_path__ + "img/blockS2-card1.0af71bae.svg";